export default __webpack_public_path__ + "static/media/Hannah_Ty_AHV_In_Moms_We_Trust.c5ff5d21.jpg";